import { Ref } from "@tblabs/truffle";
import moment from "moment";
import { DateTimeProvider } from "../Services/DateTimeProvider";
import { TimeUtils } from "./TimeUtils";


export class ExpirationTimer
{
    private timer!: NodeJS.Timeout;
    private printer = new Ref<string>("");

    public get HasTimeout(): boolean
    {
        const t = (this.timeout instanceof Ref) ? this.timeout.value : this.timeout;

        return !!t && +t > 0;
    }

    public Dispose(): void
    {
        clearInterval(this.timer);
    }

    constructor(private timeout?: Date | Ref<Date>)
    {
        if (!this.timeout)
            return;

        const t = (this.timeout instanceof Ref) ? this.timeout.value : this.timeout;

        const SecondsLeft = () => moment(t).diff(moment(DateTimeProvider.Now), 'seconds');
        const Label = () =>
        {
            const secondsLeft = SecondsLeft();
            return (secondsLeft > 0) ? `Wygasa za ${TimeUtils.FormatDuration(secondsLeft)}` : `🟠 Wygasło ${TimeUtils.FormatDuration(secondsLeft)} temu`;
        };

        this.timer = setInterval(() =>
        {
            this.printer.value = Label();
        }, 1000);

        this.printer.value = Label();
    }

    public get ExpiresIn(): Ref<string>
    {
        return this.printer;
    }
}
